module.exports = __webpack_public_path__ + "static/media/FoilingIcon.aca8b40c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon/FoilingIcon.png
// module id = 1809
// module chunks = 0